import {
  GET_COMPANY_FAIL,
  GET_COMPANY_SUCCESS,
  GET_COMPANY_LIST,
  GET_SINGLE_COMPANY_REQUEST,
  GET_SINGLE_COMPANY_SUCCESS,
  GET_SINGLE_COMPANY_FAIL,
  DELETE_COMPANY_REQUEST,
  DELETE_COMPANY_SUCCESS,
  DELETE_COMPANY_FAIL,
  ADD_COMPANY_REQUEST,
  ADD_COMPANY_SUCCESS,
  ADD_COMPANY_FAIL,
  UPDATE_COMPANY_REQUEST,
  UPDATE_COMPANY_SUCCESS,
  UPDATE_COMPANY_FAIL,
  ADD_OPERATOR_COMPANY_REQUEST,
  ADD_OPERATOR_COMPANY_SUCCESS,
  ADD_OPERATOR_COMPANY_FAIL,
  EDIT_COMPANY_STATUS_REQUEST,
  EDIT_COMPANY_STATUS_SUCCESS,
  EDIT_COMPANY_STATUS_FAIL,
  GET_OPERATOR_COMPANY_FAIL,
  GET_OPERATOR_COMPANY_SUCCESS,
  GET_OPERATOR_COMPANY_LIST,
  ADD_PUBLIC_COMPANY_SUCCESS,
  ADD_PUBLIC_COMPANY_REQUEST,
  ADD_PUBLIC_COMPANY_FAIL,
  CREATE_TELEGRAM_CHANNEL_REQUEST,
  CREATE_TELEGRAM_CHANNEL_SUCCESS,
  CREATE_TELEGRAM_CHANNEL_FAIL,
  REFRESH_MOBILE_AUTHORIZE_TOKEN_REQUEST,
  REFRESH_MOBILE_AUTHORIZE_TOKEN_SUCCESS,
  REFRESH_MOBILE_AUTHORIZE_TOKEN_FAIL,
} from "src/constants/types";

export const companyReducers = (state = {}, actions) => {
  switch (actions.type) {
    case GET_OPERATOR_COMPANY_LIST:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case GET_OPERATOR_COMPANY_SUCCESS:
      return {
        ...state,
        loading: false,
        operatorCompanies: actions.payload,
        error: "",
      };
    case GET_OPERATOR_COMPANY_FAIL:
      return {
        ...state,
        loading: false,
        error: actions.payload,
      };

    case GET_COMPANY_LIST:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case GET_COMPANY_SUCCESS:
      return {
        ...state,
        loading: false,
        companies: actions.payload,
        error: "",
      };
    case GET_COMPANY_FAIL:
      return {
        ...state,
        loading: false,
        error: actions.payload,
      };

    case GET_SINGLE_COMPANY_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case GET_SINGLE_COMPANY_SUCCESS:
      return {
        ...state,
        loading: false,
        selected_company: actions.payload,
      };
    case GET_SINGLE_COMPANY_FAIL:
      return {
        ...state,
        loading: false,
        error: actions.payload,
      };

    case REFRESH_MOBILE_AUTHORIZE_TOKEN_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case REFRESH_MOBILE_AUTHORIZE_TOKEN_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case REFRESH_MOBILE_AUTHORIZE_TOKEN_FAIL:
      return {
        ...state,
        loading: false,
        error: actions.payload,
      };

    case DELETE_COMPANY_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case DELETE_COMPANY_SUCCESS:
      return {
        ...state,
        loading: false,
        error: "",
      };
    case DELETE_COMPANY_FAIL:
      return {
        ...state,
        loading: false,
        error: actions.payload,
      };

    case ADD_COMPANY_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case ADD_COMPANY_SUCCESS:
      return {
        ...state,
        loading: false,
        error: "",
      };
    case ADD_COMPANY_FAIL:
      return {
        ...state,
        loading: false,
        error: actions.payload,
      };

    case EDIT_COMPANY_STATUS_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case EDIT_COMPANY_STATUS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: "",
      };
    case EDIT_COMPANY_STATUS_FAIL:
      return {
        ...state,
        loading: false,
        error: actions.payload,
      };

    case ADD_OPERATOR_COMPANY_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case ADD_OPERATOR_COMPANY_SUCCESS:
      return {
        ...state,
        loading: false,
        error: "",
      };
    case ADD_OPERATOR_COMPANY_FAIL:
      return {
        ...state,
        loading: false,
        error: actions.payload,
      };

    case ADD_PUBLIC_COMPANY_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case ADD_PUBLIC_COMPANY_SUCCESS:
      return {
        ...state,
        loading: false,
        error: "",
      };
    case ADD_PUBLIC_COMPANY_FAIL:
      return {
        ...state,
        loading: false,
        error: actions.payload,
      };

    case UPDATE_COMPANY_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case UPDATE_COMPANY_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case UPDATE_COMPANY_FAIL:
      return {
        ...state,
        loading: false,
        error: actions.payload,
      };

    case CREATE_TELEGRAM_CHANNEL_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case CREATE_TELEGRAM_CHANNEL_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case CREATE_TELEGRAM_CHANNEL_FAIL:
      return {
        ...state,
        loading: false,
        error: actions.payload,
      };

    default:
      return state;
  }
};
